import { makeStyles } from '@material-ui/core'
import { FC } from 'react'
import useTranslate from '../../../../i18n/useTranslate'
import { ResponseOverview } from '../../../../services/um/useDashboard'
import Items from './Items'

interface OverviewProps {
    data: ResponseOverview[]
}

const Overview: FC<OverviewProps> = ({ data }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'
    let newData = data.slice(1)
    newData = newData.filter((itm) => {
        return itm.id !== 7 && itm.id !== 8
    })

    return (
        <div className={classes.container}>
            <div className={classes.content}>
                <Items title={data[0]?.label[lang]} value={data[0]?.number} isAll={true} />
            </div>
            {newData.map((item) => {
                if (item.id === 4) {
                    //ไม่เข้าข่าย/ไม่อนุมัติ  >>> data[7].label[lang] = ไม่เข้าข่าย
                    return (
                        <div className={classes.content}>
                            <Items
                                title={`${data[7].label[lang]} / ${item.label[lang]}`}
                                value={`${data[7].number} / ${item.number}` as any}
                                isAll={false}
                            />
                        </div>
                    )
                }
                if (item.id === 5) {
                    //ยุติโครงการ/ปิดโครงการ   >>> data[6].label[lang] = ปิดโครงการ
                    return (
                        <div className={classes.content}>
                            <Items
                                title={`${item.label[lang]} / ${data[6].label[lang]}`}
                                value={`${item.number} / ${data[6].number}` as any}
                                isAll={false}
                            />
                        </div>
                    )
                } else {
                    return (
                        <div className={classes.content}>
                            <Items title={`${item.label[lang]}`} value={item.number} isAll={false} />
                        </div>
                    )
                }
            })}
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
    },
    content: {
        width: '16.66%',
        flexGrow: 1,

        overflow: 'hidden',
        [theme.breakpoints.down('md')]: {
            width: '25%',
            minWidth: '220px',
            maxWidth: '236px',
        },
        [theme.breakpoints.down('sm')]: {
            width: '33.33%',
            minWidth: '200px',
            maxWidth: '260px',
        },

        [theme.breakpoints.down('xs')]: {
            width: '100%',
            maxWidth: '400px',
        },
    },
}))

export default Overview
